import './form.scss';

export const FormNode = (model) => {
	const { title, subtitle, id } = model;

	/* html */
	const messageContainerHtml = `
    <div class="engt-msg engt-msg-bot engt-msg-formnode engt-msg-border-bot" id="engt-form-${id}">
         <p class="form-heading">${title}</p>
         <p class="form-description">${subtitle}</p>
         <div id="formFields-${id}" class="engt-form-fields">
         </div>
         <confirm-btn></confirm-btn>
         <skip-btn></skip-btn>
    </div>`;

	return messageContainerHtml;
};
